import * as yup from "yup";

const currencySchema = yup.object().shape({
  iso: yup.string().required(),
  symbol: yup.string().required()
});

// Base schemas

const agentSchema = yup.object().shape({
  id: yup.number().required(),
  name: yup.string().required(),
  email: yup.string().email().required(),
  agency_id: yup.number().required(),
  pivot: yup
    .object()
    .shape({
      realstate_id: yup.number().required(),
      people_id: yup.number().required(),
      is_no_broker: yup.number().oneOf([0, 1]).required()
    })
    .required()
});

const ownerSchema = yup.object().shape({
  id: yup.number().required(),
  name: yup.string().required(),
  identification: yup.string().required(),
  identification_type: yup.string().nullable(),
  company_name: yup.string().nullable(),
  phone: yup.string().required(),
  email: yup.string().email().nullable()
});

const improvementSchema = yup.object().shape({
  id: yup.number().required(),
  feature_values_id: yup.number().required(),
  realstate_id: yup.number().required(),
  name: yup.string().required(),
  value: yup.string().required()
});

const projectSchema = yup.object().shape({
  id: yup.number().required(),
  delivers: yup.date().required(),
  separation_price: yup
    .string()
    .matches(/^\d+(\.\d{1,2})?$/, "Debe ser un número válido")
    .required(),
  separation_currency: currencySchema.required(),
  sets_count: yup.number().required(),
  units_count: yup.number().required(),
  minimum_price: yup
    .string()
    .matches(/^\d+(\.\d{1,2})?$/, "Debe ser un número válido")
    .required(),
  maximum_price: yup
    .string()
    .matches(/^\d+(\.\d{1,2})?$/, "Debe ser un número válido")
    .required()
});

// Main schema using composed parts
const propertyCheckConflictSchema = yup.object().shape({
  id: yup.number().required(),
  parent_id: yup.number().required(),
  slug: yup.string().required(),
  name: yup.string().required(),
  property_title: yup.string().required(),
  is_favorite: yup.number().oneOf([0, 1]).required(),
  address: yup.string().required(),
  price: yup
    .string()
    .matches(/^\d+(\.\d{1,2})?$/, "Debe ser un número válido")
    .required(),
  alternate_price: yup
    .string()
    .matches(/^\d+(\.\d{1,2})?$/, "Debe ser un número válido")
    .required(),
  total_comission: yup
    .string()
    .matches(/^\d+(\.\d{1,2})?$/, "Debe ser un número válido")
    .required(),
  currency: currencySchema.required(),
  alternative_currency: currencySchema.required(),
  agent_list: yup.array().of(agentSchema).required(),
  business_type: yup.string().required(),
  arrangement: yup.string().required(),
  realstatetype_id: yup.number().required(),
  realstate_type: yup.string().required(),
  sqm_construction: yup.number().nullable(),
  sqm_land: yup.number().nullable(),
  pumps: yup.number().nullable(),
  parking_spots: yup.number().nullable(),
  floor_level: yup.number().nullable(),
  floors_total: yup.number().nullable(),
  bedrooms: yup.number().nullable(),
  bathrooms: yup.number().nullable(),
  half_bathrooms: yup.number().nullable(),
  city: yup.string().required(),
  city_id: yup.number().required(),
  sector: yup.string().required(),
  sector_id: yup.number().required(),
  latitude: yup.number().required(),
  longitude: yup.number().required(),
  maintenance_fee: yup.number().nullable(),
  is_collection: yup.number().oneOf([0, 1]).required(),
  status: yup.string().required(),
  status_id: yup.number().required(),
  condition_status: yup.string().required(),
  trust_entity_id: yup.number().nullable(),
  trust_entity_name: yup.string().nullable(),
  improvements: yup.array().of(improvementSchema).nullable(),
  videos: yup.array().of(yup.string()).nullable(),
  main_picture: yup
    .object()
    .shape({
      big: yup.string().url().required(),
      small: yup.string().url().required()
    })
    .nullable(),
  views_counter: yup.number().required(),
  likes_counter: yup.number().required(),
  project: projectSchema.nullable(),
  info: yup
    .array()
    .of(
      yup.object().shape({
        realstate_id: yup.number().required(),
        language_id: yup.number().required(),
        title: yup.string().required()
      })
    )
    .nullable(),
  agents: yup.array().of(agentSchema).nullable(),
  owners: yup.array().of(ownerSchema).required()
});

const CPropertyCheckConflictResponse = yup.object({
  data: yup.array().of(propertyCheckConflictSchema).required().default([]),
  status: yup.number().required().default(0),
  message: yup.string().required().default("")
});

export type PropertyCheckConflictData = yup.InferType<
  typeof propertyCheckConflictSchema
>;
export type IPropertyCheckConflictResponse = yup.InferType<
  typeof CPropertyCheckConflictResponse
>;
export const transformPropertyCheckConflict = async (
  data: IPropertyCheckConflictResponse
) => {
  try {
    await CPropertyCheckConflictResponse.isValid(data);
    return data;
  } catch (error) {
    console.log(error, "conflict property error");
    return data;
  }
};
